import { TestCreditCardGenerator } from '@paypalcorp/developeruikit'
import '@paypalcorp/developeruikit/lib/cjs/index.css'
import React from 'react'
import Layout from '../layout'

import { useApplicationContext } from '../../provider'

export default function Home(props) {
  const { user } = useApplicationContext()
  const userLoggedIn = user && user.loggedIn

  return (
    <Layout
      leftNavBar={true}
      layout="dx-docs"
      activeNavLocal
      location={props.location}
    >
      <div id="hashLinkContainer" />
      <main
        className="content dx-content"
        id={userLoggedIn ? 'Authed' : 'Unauthed'}
      >
        <div className="" style={{}}>
          <h1
            className="homepageTitle"
            data-testid="header-title"
            style={{
              textAlign: 'center',
            }}
          >
            Test Card Manager
          </h1>
          <TestCreditCardGenerator
            handleSelectedCard={(card) => {
            }}
          />
        </div>
        <br />
      </main>
    </Layout>
  )
}
